import { render } from "./LsListPage.vue?vue&type=template&id=f5280a92&scoped=true"
import script from "./LsListPage.vue?vue&type=script&lang=js"
export * from "./LsListPage.vue?vue&type=script&lang=js"

import "./LsListPage.vue?vue&type=style&index=0&id=f5280a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5280a92"]])

export default __exports__